import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './context-menu.styles'
import DropMenu from 'pobble-components/dist/drop-menu'
import MoreButton from 'pobble-components/dist/more-button'
import TrashIcon from 'react-icons/lib/fa/trash'
import AddUserIcon from 'react-icons/lib/fa/user-plus'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const ContextMenu = ({
  classes,
  onDelete,
  onOpenInvitationAssessmentDialog
}) => (
  <DropMenu
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        <Fragment>
          <MenuItem
            onClick={() => {
              onOpenInvitationAssessmentDialog()
              closePopover()
            }}>
            <IconHolder>
              <AddUserIcon />
            </IconHolder>
            Invite contributor
          </MenuItem>
          <MenuItem
            className={classes.delete}
            onClick={() => {
              openConfirmationDialog({
                bodyText: `Are you sure you want to delete this moderation file?`,
                confirmText: `Delete moderation file`,
                action: onDelete
              })
              closePopover()
            }}>
            <IconHolder>
              <TrashIcon />
            </IconHolder>
            Delete moderation file
          </MenuItem>
        </Fragment>
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
